import React from 'react';
import DateSelector from "../../lib/DateSelector/DateSelector";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface WaiverDateSelectorProps {
  label: string;
  required?: boolean;
  includeTime?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  errorTooltip?: boolean;
  onClick?: () => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
}

class WaiverDateSelector extends React.Component<WaiverDateSelectorProps> {
  getLabel() {
    const asterisk = this.props.required ? '*' : '';
    return this.props.label + asterisk;
  }

  render() {
    return (
      <div className="form-group">
        <label>{this.getLabel()}:</label>
        <div className='date-selector'>
          <OverlayTrigger delay={{ hide: 450, show: 300 }} show={this.props.errorTooltip} placement="bottom"
            overlay={(props) => (
              <>
                <Tooltip {...props} bsPrefix='waiver-error-tooltip popover datepicker-error-tooltip'>
                  <div className="popover-inner">
                    <div className="popover-content">
                      <span className="sprites sprite-details-selected-24"></span>Please fill this field.
                    </div>
                  </div>
                </Tooltip>
              </>
            )}>
            <div><DateSelector
              includeTime={this.props.includeTime}
              value={this.props.value || null}
              time={this.props.value ? new Date(this.props.value) : undefined}
              dateFormat="yyyy-MM-dd"
              onChange={this.props.onChange as any}
              required={this.props.required}
              placeholderText={this.props.placeholder}
              onClick={this.props.onClick}
              onBlur={this.props.onBlur}
              className={this.props.className}
            /></div>
          </OverlayTrigger>
        </div>
      </div>
    );
  }
}

export default WaiverDateSelector;